export default __webpack_public_path__ + "static/media/Recruit's Cloak.dc4b7f2b.jpg";